


























import { defineComponent, PropType } from '@vue/composition-api';
import { EventBucketType } from '@front-app/hooks/useEventBuckets';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { useTranslate } from '@front-app/hooks/useTranslate';
import GridList from './GridList.vue';

export default defineComponent({
	components: {
		GridList,
	},
	props: {
		groupId: {
			type: String,
			default: '',
		},
		eventBucketType: {
			type: String as PropType<EventBucketType>,
			required: true,
		},
		date: {
			type: Date,
			required: true,
		},
		events: {
			type: Array as PropType<EventV2[]>,
			required: true,
		},
		bannerLocation: {
			type: String as PropType<BannerLocation>,
			required: true,
		},
	},
	setup(props, ctx) {
		const $t = useTranslate(ctx);

		const getEventBucketTitle = () => {
			if (props.eventBucketType === EventBucketType.ACTIVE) {
				return $t('events.day-list.happening-today');
			}

			if (props.eventBucketType === EventBucketType.COMING_SOON) {
				return $t('events.day-list.coming-soon');
			}

			return ctx.root.$d(new Date(props.date), 'yearAndMonth');
		};

		return {
			EventBucketType,
			getEventBucketTitle,
		};
	},
});
